import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=0652d127&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Basic.vue?vue&type=style&index=0&id=0652d127&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0652d127",
  null
  ,true
)

export default component.exports